import { render, staticRenderFns } from "./PlatformsDetailDialog.vue?vue&type=template&id=b188e4f2"
import script from "./PlatformsDetailDialog.vue?vue&type=script&lang=js"
export * from "./PlatformsDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PlatformsDetailDialog.vue?vue&type=style&index=0&id=b188e4f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports